import generateTypes from '../../utils/generateTypes';

export const GET_MEETINGS_INTERVALS = generateTypes('GET_MEETINGS_INTERVALS');
export const RESET_MEETINGS_INTERVALS = generateTypes(
    'RESET_MEETINGS_INTERVALS'
);
